import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';

import messages from '../../messages';
import FiltersRefinementCount from '../FiltersRefinementCount';

import {IFiltersRefinementIndicatorProps} from './IFiltersRefinementIndicator';

import styles from './FiltersRefinementIndicator.module.scss';

const FiltersRefinementIndicator = ({refinement}: IFiltersRefinementIndicatorProps) => {
	const intl = useIntl();

	const label = useMemo(() => {
		if (!refinement) {
			return '';
		}

		const fallbackLabel = refinement.getLabel();
		const attributeId = refinement.getAttributeId();

		return messages[attributeId]
			? intl.formatMessage(messages[attributeId]) || fallbackLabel
			: fallbackLabel;
	}, [refinement]);

	if (!refinement) {
		return null;
	}

	return (
		<span className={styles['filters-refinement__indicator']}>
			<span>{label}</span>
			<FiltersRefinementCount count={refinement.getActiveValuesCount()}/>
		</span>
	);
};
export default FiltersRefinementIndicator;